module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classeLaucher"
  }, [_c('div', {
    staticClass: "sc-launcher",
    class: {
      opened: _vm.isOpen
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isOpen ? _vm.close() : _vm.open()
      }
    }
  }, [(_vm.newMessagesCount > 0 && !_vm.isOpen) ? _c('div', {
    staticClass: "sc-new-messsages-count"
  }, [_vm._v("\n      " + _vm._s(_vm.newMessagesCount) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "sc-open-icon",
    attrs: {
      "src": require("./assets/close-icon.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sc-closed-icon",
    attrs: {
      "src": require("./assets/logo-no-bg.svg")
    }
  })]), _vm._v(" "), _c('ChatWindow', {
    attrs: {
      "messageList": _vm.messageList,
      "mensagens": _vm.mensagens,
      "onUserInputSubmit": _vm.onMessageWasSent,
      "isOpen": _vm.isOpen,
      "onClose": _vm.close,
      "showEmoji": _vm.showEmoji,
      "showFile": _vm.showFile,
      "placeholder": _vm.placeholder
    },
    on: {
      "sendMsg": _vm.sendMsg,
      "escolheuCliente": _vm.leuMsg,
      "atualizarImagem": _vm.atualizarImagem,
      "backChat": _vm.backChat
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd7dc8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/Launcher.vue
// module id = 1299
// module chunks = 1